module.exports = __webpack_public_path__ + "assets/img/00172.89c83090.png";